import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelSettingsAuditsErrorStatesEnum {
  GetAuditsFailed = ErrorStateScheduleEnum.PanelSettingsAuditsErrorStatesStartIndex
}
